import { PaymentRecipient } from '../../store/PaymentRecipient';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const getPaymentRecipient = (id: string) => {
  return apiService.callExternalApi<PaymentRecipient>({
    url: `${API_SERVER_URL}/payment-recipients/${id}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const listPaymentRecipients = () => {
  return apiService.callExternalApi<PaymentRecipient[]>({
    url: `${API_SERVER_URL}/payment-recipients`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const patchPaymentRecipient = (paymentRecipient: PaymentRecipient) => {
  return apiService.callExternalApi<PaymentRecipient>({
    url: `${API_SERVER_URL}/payment-recipients/${paymentRecipient.id}`,
    method: 'PUT',
    headers: {
      'content-type': 'application/json'
    },
    data: JSON.stringify(paymentRecipient)
  });
};

export const createPaymentRecipient = (paymentRecipient: PaymentRecipient) => {
  return apiService.callExternalApi<PaymentRecipient>({
    url: `${API_SERVER_URL}/payment-recipients`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: JSON.stringify(paymentRecipient)
  });
};

export const deletePaymentRecipient = (id: string) => {
  return apiService.callExternalApi<void>({
    url: `${API_SERVER_URL}/payment-recipients/${id}`,
    method: 'DELETE',
    headers: {
      'content-type': 'application/json'
    }
  });
};
